import { faCheck, faExclamationTriangle, faClose, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Box, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { WhiteInput } from "../../../../../components/Inputs/InputText";
import { base64toBlob } from "../../../../../infra/utils/Files";
import { downloadConteudoBase64 } from "../../../../../infra/utils/DownloadFile";
import { BlueHoverButton } from "../../../../../components/Inputs/BlueHoverButton";
import servAnalises from "../../../../../services/login/servAnalises";
import ServSolicitacaoCompartilhamentoDocs from "../../../../../services/login/servSolicitacaoCompartilhamentoDocs";
import styles from "../SolicitacaoSolCompartilhamentoAnalise.module.css";
import servConsultaDisponibilidade from "../../../../../services/login/servConsultaDisponibilidade";

const SituacaoAnalise = ({
    Situacao,
    TipoParecer,
    Parecer,
    SituacaoSolicCompartilhamento,
    CodigoSolicCompart,
    CodigoAnalise,
    setIsLoading,
    setSeverity,
    setOpenDownload,
    setDownloadMessage,
    isObservacaoGeral = false
}) => {
    const [docsParaDownload, setDocsParaDownloads] = useState([]);

    useEffect(() => {

        const recuperarDocs = async () => {
            try {
                const docs = await ServSolicitacaoCompartilhamentoDocs.listarPersonalizado(CodigoSolicCompart);

                if (docs.Success) {
                    let documentos = docs.Content;

                    setDocsParaDownloads(documentos);
                }
            } catch (err) {
                console.log(err);
            }
        }

        if (CodigoAnalise && Situacao !== 1 && TipoParecer === "geral") {
            recuperarDocs();
        }
    }, []);


    const handleDownloadRelacionamentoOperacional = async (docs) => {
        try {

            if (CodigoAnalise) {
                setIsLoading(true);
                setOpenDownload(true);
                setSeverity("info");
                setDownloadMessage("Iniciando download do documento...");

                const CodigoDocumento = docs.find(doc => doc.TipoDocumento === 2)?.CodigoDocumento;

                let data = await servAnalises.recuperarRelacionamentoOperacional(
                    CodigoSolicCompart,
                    CodigoDocumento
                );

                setIsLoading(false);
                setOpenDownload(true);
                setSeverity("success");
                setDownloadMessage("Download iniciado com sucesso...");

                downloadConteudoBase64(data.Content.Nome, data.Content.Arquivo);
            }

        } catch (err) {
            setSeverity("error");
            setOpenDownload(true);
            setIsLoading(false);
            let statusErrorMessage = err.response.status + " - " + err.response.statusText;

            setDownloadMessage(err.response.data.Message ? err.response.data.Message : statusErrorMessage);
        }
    }

    const handleVisualizarParecer = async (docs) => {
        try {
            if (!docs) return;

            const CodigoDocumento = docs.find(doc => doc.TipoDocumento === 1)?.CodigoDocumento;

            setIsLoading(true);

            const data = await servAnalises.visualizarParecerAnalise(
                CodigoSolicCompart,
                CodigoDocumento
            );

            const blob = base64toBlob(data.Content.Arquivo, "application/pdf");

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob);
            } else {
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, "_blank");
            }

            setIsLoading(false);

        } catch (err) {
            setSeverity("error");
            setOpenDownload(true);
            setIsLoading(false);

            const statusErrorMessage = err.response?.status
                ? `${err.response.status} - ${err.response.statusText}`
                : "Erro desconhecido";

            setDownloadMessage(err.response?.data?.Message || statusErrorMessage);
        }
    };

    return (
        <div className={styles.situacaoAnalise}>
            <div className={
                Situacao == 0
                    ? `${styles.resultadoAnaliseParcial} + ${styles.NaoAvaliado}`
                    : Situacao == 1
                        ? `${styles.resultadoAnaliseParcial} + ${styles.Favoravel}`
                        : Situacao == 2
                            ? `${styles.resultadoAnaliseParcial} + ${styles.FavoravelRessalvas}`
                            : `${styles.resultadoAnaliseParcial} + ${styles.Reprovado}`
            } style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                <h3> {TipoParecer === 'geral' ? "Parecer geral" : `Parecer ${TipoParecer}`}</h3>
                <div className={styles.parecerSituacao}>
                    Situação:
                    {
                        SituacaoSolicCompartilhamento !== 1 && Situacao === 0
                            ? " Não avaliado"
                            : SituacaoSolicCompartilhamento !== 1 && Situacao === 1
                                ? " Favorável"
                                : SituacaoSolicCompartilhamento !== 1 && Situacao === 2
                                    ? " Favorável com Ressalvas"
                                    : SituacaoSolicCompartilhamento !== 1 && Situacao === 3
                                        ? " Reprovada"
                                        : " Não avaliado"
                    }
                    <p><FontAwesomeIcon
                        size="lg"
                        icon=
                        {
                            SituacaoSolicCompartilhamento !== 1 && Situacao === 0
                                ? faRefresh
                                : SituacaoSolicCompartilhamento !== 1 && Situacao === 1
                                    ? faCheck
                                    : SituacaoSolicCompartilhamento !== 1 && Situacao === 2
                                        ? faExclamationTriangle
                                        : SituacaoSolicCompartilhamento !== 1 && Situacao === 3
                                            ? faClose
                                            : ""
                        }
                    />
                    </p>
                </div>
            </div>
            {(Situacao !== 1 && TipoParecer === "geral") && (
                <div>
                    {docsParaDownload.filter(doc => doc.TipoDocumento === 1).length > 0 && (
                        <BlueHoverButton style={{ marginTop: "10px" }} onClick={() => handleVisualizarParecer(docsParaDownload)} sx={{ marginRight: 3 }}>Visualizar parecer análise</BlueHoverButton>
                    )}
                    {docsParaDownload.filter(doc => doc.TipoDocumento === 2).length > 0 && (
                        <BlueHoverButton style={{ marginTop: "10px" }} onClick={() => handleDownloadRelacionamentoOperacional(docsParaDownload)} sx={{ marginRight: 3 }}>Baixar doc. solicitação de compartilhamento</BlueHoverButton>
                    )}
                </div>
            )}
            {!isObservacaoGeral && <div className={styles.parecerAnalise}>
                <div className={styles.ressalvasEMotivos}>
                    <p>Observações {TipoParecer}:</p>
                </div>
                <WhiteInput
                    value={Parecer}
                    id="parecer-observacao"
                    disabled
                    rows={3}
                    multiline
                    sx={{
                        width: "100%",
                        marginRight: "10px",
                        color: "#B8B8B8",
                        overflow: "auto",
                        fontSize: "14px",
                        overflowY: "auto",
                        resize: "none",
                        "& .MuiInputBase-inputMultiline": {
                            padding: "10px",
                            minHeight: "60px !important",
                            height: "auto !important",
                        },
                        "& .MuiOutlinedInput-root": {
                            padding: "0 !important",
                        }
                    }}
                />
            </div>}
        </div>
    )
}

const ResultadoAnalise = ({ record, recordForView, setIsLoading, fazFiscalizacao }) => {
    const [severity, setSeverity] = useState("info");
    const [openDownload, setOpenDownload] = useState(false);
    const [downloadMessage, setDownloadMessage] = useState("");
    const [disponibilizaMapas, setDisponibilizaMapas] = useState(false);

    const handleCloseInfo = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenDownload(false);
        }

        setOpenDownload(false);
    }

    useEffect(() => {
        const buscarParametros = async () => {
            try {
                const [paramsMapa] = await Promise.all([
                    servConsultaDisponibilidade.BuscarParametros(),
                ]);

                const disponibilizaMapas = Boolean(paramsMapa?.Content?.[0]?.DisponibilizaMapas);

                setDisponibilizaMapas(disponibilizaMapas);

            } catch (err) {
                console.error("Erro ao buscar parâmetros:", err);
            }
        };

        buscarParametros();
    }, []);

    const parecerGeral = () => {
        const pareceres = [
            recordForView?.row?.ParecerRepresentante ?? recordForView?.ParecerRepresentante,
            recordForView?.row?.ParecerDocumentos ?? recordForView?.ParecerDocumentos,
            recordForView?.row?.ParecerProjeto ?? recordForView?.ParecerProjeto,
            fazFiscalizacao
                ? (recordForView?.row?.ParecerInstalacao ?? recordForView?.ParecerInstalacao)
                : null
        ].filter(p => p !== null && p !== undefined);

        if (pareceres.includes(0)) return 0;
        if (pareceres.every(p => p === 1)) return 1;
        if (pareceres.every(p => p === 2)) return 2;
        if (pareceres.includes(3)) return 3;

        return 0;
    }

    if (!recordForView || !record) {
        return (
            <div className={styles['resultado-analise']}>
                <Box style={{ margin: '25px auto 0 auto' }}>Análise não encontrada.</Box>
            </div>
        );
    }

    return (
        <div className={styles.modalMain}>
            <SituacaoAnalise
                Situacao={parecerGeral()}
                TipoParecer="geral"
                Parecer={
                    recordForView?.row?.MotivoReprovacao || recordForView?.MotivoReprovacao
                }
                SituacaoSolicCompartilhamento={recordForView?.row?.Situacao || recordForView?.SituacaoSolicitacao}
                CodigoSolicCompart={recordForView?.row?.CodigoSolicCompart || recordForView?.CodigoSolicCompart}
                CodigoAnalise={recordForView?.row?.Id || recordForView?.Id}
                setIsLoading={setIsLoading}
                setSeverity={setSeverity}
                setOpenDownload={setOpenDownload}
                setDownloadMessage={setDownloadMessage}
            />
            <SituacaoAnalise
                Situacao={recordForView?.row?.ParecerRepresentante || recordForView?.ParecerRepresentante}
                TipoParecer="do representante"
                Parecer={
                    recordForView?.row?.ObservacaoRepresentante || recordForView?.ObservacaoRepresentante
                }
                SituacaoSolicCompartilhamento={recordForView?.row?.Situacao || recordForView?.SituacaoSolicitacao}
            />
            <SituacaoAnalise
                Situacao={recordForView?.row?.ParecerDocumentos || recordForView?.ParecerDocumentos}
                TipoParecer="do documentos"
                Parecer={
                    recordForView?.row?.ObservacaoDocumentos || recordForView?.ObservacaoDocumentos
                }
                SituacaoSolicCompartilhamento={recordForView?.row?.Situacao || recordForView?.SituacaoSolicitacao}
            />
            {disponibilizaMapas && <SituacaoAnalise
                Situacao={recordForView?.row?.ParecerProjeto || recordForView?.ParecerProjeto}
                TipoParecer="do projeto"
                Parecer={
                    recordForView?.row?.ObservacaoProjeto || recordForView?.ObservacaoProjeto
                }
                SituacaoSolicCompartilhamento={recordForView?.row?.Situacao || recordForView?.SituacaoSolicitacao}
            />}
            {fazFiscalizacao && <SituacaoAnalise
                Situacao={recordForView?.row?.ParecerInstalacao || recordForView?.ParecerInstalacao}
                TipoParecer="da instalação"
                Parecer={
                    recordForView?.row?.ObservacaoInstalacao || recordForView?.ObservacaoInstalacao
                }
                SituacaoSolicCompartilhamento={recordForView?.row?.Situacao || recordForView?.SituacaoSolicitacao}
            />}
            <Snackbar open={openDownload} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={1000} onClose={handleCloseInfo}>
                <Alert onClose={handleCloseInfo} severity={severity} sx={{ width: '100%' }} >
                    {downloadMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}

export { ResultadoAnalise }